import _ from 'underscore';

// Do not wrap the function by _.memoize or _.once, because siteMap can change based on scope.
export function buildReportTypeMapping(siteMap, id = 'reports-v4-default-reports') {
  const mapping = {};
  const defaultReportItem = _.findWhere(siteMap[0].children, { id });

  defaultReportItem.children.forEach((category) => {
    category.children.forEach((report) => {
      mapping[report.apiKey] = {
        name: report.name,
        route: report.route,
      };
    });
  });

  return mapping;
}

export function buildCustomReportTypeMapping(siteMap) {
  const mapping = {};
  const pageId = siteMap[0].id === 'reporting' ? 'reporting-template-reports' : 'reports-v4-default-reports';
  const defaultReportItem = _.findWhere(siteMap[0].children, { id: pageId });

  defaultReportItem.children.forEach((category) => {
    category.children.forEach((report) => {
      mapping[report.apiKey] = {
        name: report.name,
        route: report.route.includes('create') ? report.route.replace('reports-v4', 'reporting') : report.route,
      };
    });
  });

  return mapping;
}
